import React, {useEffect, useState} from "react";
import {HealthCheckupDateComponent} from "../../component/visit-application/visit-health-checkup-date";
import Api from '../../interface/api/visit/in-out';

function close(){
    window.open('/admin/visitor-list', '_self');
}

export default function InoutView(props) {
    const {location, match} = props;

    const [visitorInfo, setVisitorInfo] = useState<any>();
    const [hostYn, setHostYn] = React.useState({
        flag: false
    });

    function visitInfoChangeHandler(e) {
        setVisitorInfo({...visitorInfo, [e.target.name] : e.target.value });
    }

    function stuffInfoChangeHandler(stuffInfo, e) {
        setVisitorInfo({
            ...visitorInfo,
            checkStuffInfoVOS: visitorInfo.checkStuffInfoVOS.map(row => stuffInfo.seq === row.seq ? {
                ...row,
                [e.target.name]: e.target.value
            } : {...row})
        });
    }

    useEffect(() => {
        let visitorInfoSeq = match.params.visitorInfoSeq;
        if(visitorInfoSeq !== undefined) {
            Api.getVisitorInOutInfo(visitorInfoSeq).then(res => {
                setVisitorInfo (res.data);
            })
        }
    }, [match.params.visitorInfoSeq])

    return (
        <div className="admin nv_wrap info_wrap">
            <div className="innerbox">
                <p className="close" onClick={close} >닫기</p>
                {/*<h1 className="info_logo">솔브레인</h1>*/}
                {
                    visitorInfo !== undefined &&
                    <>
                        <div className="tablebox" style={{paddingTop: '30px'}}>
                            <h3>방문 정보</h3>
                            <table className="info_table" cellPadding="0" cellSpacing="0">
                                <tbody>
                                <tr>
                                    <th>방문자</th>
                                    <th>방문기간</th>
                                </tr>

                                <tr>
                                    <td>{visitorInfo.visitorName}</td>
                                    <td>
                                        {`${visitorInfo.visitFromDate}:00시 ~`}

                                        {`${visitorInfo.visitToDate}:00시`}
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                        <div className="tablebox" style={{paddingTop: '30px'}}>
                            <table className="info_table" cellPadding="0" cellSpacing="0">
                                <tbody>
                                <tr>
                                    <th>업체명</th>
                                    <th>연락처</th>
                                    <th>방문목적</th>
                                    <th>방문위치</th>
                                </tr>
                                <tr>
                                    <td>{visitorInfo.visitorCompany}</td>
                                    <td>{visitorInfo.visitorPhone}</td>
                                    <td>{visitorInfo.visitorPurpose} - {visitorInfo.visitorPurposeDetail}</td>
                                    <td>{visitorInfo.visitorLocation}</td>
                                </tr>
                                <tr>
                                    <th>차량번호</th>
                                    <th>접견인</th>
                                    <th>접견인 회사</th>
                                    <th>접견인 팀</th>
                                </tr>
                                <tr>
                                    <td>{visitorInfo.visitorCar}</td>
                                    <td>{visitorInfo.hostName}</td>
                                    <td>{visitorInfo.hostCompany}</td>
                                    <td>{visitorInfo.hostTeam}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        {
                            visitorInfo.visitorStatus === '승인' &&
                            <CheckInComponent
                                siteInfo = { JSON.parse(localStorage.getItem('siteInfo') || '{}') }
                                visitorInfo = { visitorInfo }
                                setVisitorInfo = { setVisitorInfo }
                                visitInfoChangeHandler = { visitInfoChangeHandler }
                                stuffInfoChangeHandler = { stuffInfoChangeHandler }
                            />
                        }
                        {
                            visitorInfo.visitorStatus === '입문' &&
                            <CheckOutComponent
                                visitorInfo={visitorInfo}
                                visitInfoChangeHandler={visitInfoChangeHandler}
                                stuffInfoChangeHandler={stuffInfoChangeHandler} />
                        }
                        {
                            visitorInfo.visitorStatus === '출문' &&
                            <ReCheckInComponent visitorInfo={visitorInfo}/>
                        }
                    </>
                }
                {/*<p className=comment>*/}
                {/*    <span className="tit">반려사유 : </span>*/}
                {/*    <span className="info">반려 내용</span>*/}
                {/*</p>*/}
            </div>
        </div>
    )
}

function CheckInComponent({siteInfo, visitorInfo, setVisitorInfo, visitInfoChangeHandler, stuffInfoChangeHandler}) {
    function submit() {

        let healthCheckupDate = '';
        if(visitorInfo.healthCheckupDate !== undefined) {
            healthCheckupDate = visitorInfo.healthCheckupDate;
        }
        // e.preventDefault();
        Api.visitorInOutCheckIn({
            visitorInfoSeq : visitorInfo.visitorInfoSeq,
            visitorHistoryInfoSeq : visitorInfo.visitorHistoryInfoSeq,
            visitorHealthCheckupDate : healthCheckupDate,
            card : visitorInfo.card,
            /*temperature : visitorInfo.temperature,*/
            checkStuffInfoVOS : visitorInfo.checkStuffInfoVOS
        }).then(res =>  {
            alert('정상적으로 처리되었습니다.');
            close();
        });
    }

    function reMind() {
        Api.reMind(visitorInfo.visitorInfoSeq).then(res => alert('정상적으로 발송되었습니다.\r\n문진표 작성완료 후 QR코드를 다시 리딩해주세요.'))
    }

    return (
        // <form onSubmit={submit} style={{textAlign:'center'}}>
        <div className="tablebox" style={{paddingTop: '30px',textAlign:'center'}}>
            <h3 style={{textAlign:'left'}}>입출문 정보</h3>
            <table className="info_table" cellPadding="0" cellSpacing="0">
                <thead>
                <tr>
                    <th>방문일</th>
                    <th>방문증</th>
                    {
                        siteInfo.name !== '솔브레인에스엘디' &&
                            (visitorInfo.visitorPurpose === '안전작업' || visitorInfo.visitorPurpose === '유지보수') &&
                                <th>건강검진일</th>
                    }
                    <th>입문일시</th>
                    <th>퇴문일시</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{visitorInfo.date}</td>
                    <td>
                        <select name="card" className="user nv_select_box"
                                onChange={visitInfoChangeHandler}
                                style={{width:'100px'}}
                        >
                            <option selected value={''}>내방증</option>
                            <option value={'사원증'}>사원증</option>
                        </select>
                        {
                            visitorInfo.card !== '사원증' &&
                            <input type='text'
                                   className={"nv_input"}
                                   name='card'
                                   onChange={visitInfoChangeHandler}
                                   style={{width:'100px'}}
                            />
                        }
                    </td>
                    {
                        siteInfo.name !== '솔브레인에스엘디' &&
                            (visitorInfo.visitorPurpose === '안전작업' || visitorInfo.visitorPurpose === '유지보수') &&
                                <td>
                                    <HealthCheckupDateComponent selectedHandler={
                                        (date) =>
                                            setVisitorInfo({...visitorInfo, healthCheckupDate:date})
                                    }/>
                                </td>
                    }
                    <td>{visitorInfo.checkInTime}</td>
                    <td>{visitorInfo.checkOutTime}</td>
                </tr>
                {/*문진표 삭제요청으로 인한 주석처리*/}
                {/*<tr>
                    {
                        visitorInfo.surveyVo !== null
                            ?
                            <td colSpan={
                                siteInfo.name !== '솔브레인에스엘디' &&
                                    (visitorInfo.visitorPurpose === '안전작업' || visitorInfo.visitorPurpose === '유지보수')
                                ? 5
                                : 4
                            }>
                                <table className="info_table" cellPadding="0" cellSpacing="0">
                                    <tbody>
                                    <tr>
                                        <th>위험지역방문여부</th>
                                        <th>증상</th>
                                        <th>온도</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            {
                                                visitorInfo.surveyVo.visitAreaDangerous === 'true'
                                                    ? `예(${visitorInfo.surveyVo.visitAreas1}, ${visitorInfo.surveyVo.visitAreas2}, ${visitorInfo.surveyVo.visitAreas3})`
                                                    : '아니요'
                                            }
                                        </td>
                                        <td>
                                            {visitorInfo.surveyVo.symptoms.map(row => row)}
                                        </td>
                                        <td>
                                            <input type={"text"}
                                                   className={"nv_input"}
                                                   name={'temperature'}
                                                   onChange={visitInfoChangeHandler}
                                            />
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                            :
                            <td colSpan={
                                siteInfo.name !== '솔브레인에스엘디' &&
                                (visitorInfo.visitorPurpose === '안전작업' || visitorInfo.visitorPurpose === '유지보수')
                                    ? 5
                                    : 4
                            }>
                                <table className="info_table" cellPadding="0" cellSpacing="0">
                                    <tbody>
                                    <tr>
                                        <th>문진표 미작성</th>
                                        <th>온도</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            <button type="button" className="nv_blue_button" onClick={reMind}>문진표 작성 링크 발송</button>
                                        </td>
                                        <td>
                                            <input type={"text"}
                                                   className={"nv_input"}
                                                   name={'temperature'}
                                                   onChange={visitInfoChangeHandler}
                                            />
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                    }
                </tr>*/}
                <tr>
                    <td colSpan={
                        siteInfo.name !== '솔브레인에스엘디' &&
                        (visitorInfo.visitorPurpose === '안전작업' || visitorInfo.visitorPurpose === '유지보수')
                            ? 5
                            : 4
                    }>
                        <table className="info_table" cellPadding="0" cellSpacing="0">
                            <tbody>
                            <tr>
                                <th>구분</th>
                                <th>시리얼번호</th>
                                <th>사용목적</th>
                                <th>비고</th>
                                <th>반입용량</th>
                            </tr>
                            {
                                visitorInfo.checkStuffInfoVOS.map((row, index) => (
                                    <tr key={`stuffInfosKey-${index}`}>
                                        <td>{row.category}</td>
                                        <td>{row.serialNo}</td>
                                        <td>{row.purpose}</td>
                                        <td>{row.notice}</td>
                                        <td>
                                            <input type={"text"}
                                                   className={"nv_input"}
                                                   name={'beforeData'}
                                                   onChange={(e) => stuffInfoChangeHandler(row, e)}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
            <button type="button" className="info_visit_btn" onClick={submit}>입문</button>
        </div>
        //    </form>
    )
}

function CheckOutComponent({visitorInfo, visitInfoChangeHandler, stuffInfoChangeHandler}) {
    function submit() {
        // e.preventDefault();
        Api.visitorInOutCheckOut({
            visitorInfoSeq : visitorInfo.visitorInfoSeq,
            visitorHistoryInfoSeq : visitorInfo.visitorHistoryInfoSeq,
            outCard : visitorInfo.outCard,
            checkStuffInfoVOS : visitorInfo.checkStuffInfoVOS
        }).then(res =>  {
            alert('정상적으로 처리되었습니다.');
            close();
        });
    }
    return (
        // <form onSubmit={submit} style={{textAlign:'center'}}>
        <div className="tablebox" style={{paddingTop: '30px',textAlign:'center'}}>
            <h3 style={{textAlign:'left'}}>입출문 정보</h3>
            <table className="info_table" cellPadding="0" cellSpacing="0">
                <thead>
                <tr>
                    <th>방문일</th>
                    <th>방문증</th>
                    <th>방문증 확인</th>
                    <th>입문일시</th>
                    <th>퇴문일시</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{visitorInfo.date}</td>
                    <td>{visitorInfo.card}</td>
                    <td>
                        <input type={"text"}
                               className={"nv_input"}
                               name={'outCard'}
                               onChange={visitInfoChangeHandler}
                        />
                    </td>
                    <td>{visitorInfo.checkInTime}</td>
                    <td>{visitorInfo.checkOutTime}</td>
                </tr>
               {/* <tr>
                    <td colSpan={5}>
                        <table className="info_table" cellPadding="0" cellSpacing="0">
                            <tbody>
                            <tr>
                                <th>위험지역방문여부</th>
                                <th>증상</th>
                                <th>온도</th>
                                {
                                    visitorInfo.visitorHealthCheckupDate !== undefined &&
                                        <th>건강검진일</th>
                                }
                            </tr>
                            <tr>
                                <td>
                                    {
                                        visitorInfo.surveyVo.visitAreaDangerous === 'true'
                                            ? `예(${visitorInfo.surveyVo.visitAreas1}, ${visitorInfo.surveyVo.visitAreas2}, ${visitorInfo.surveyVo.visitAreas3})`
                                            : '아니요'
                                    }
                                </td>
                                <td>
                                    {visitorInfo.surveyVo.symptoms.map(row => row)}
                                </td>
                                <td>{visitorInfo.temperature}</td>
                                {
                                    visitorInfo.visitorHealthCheckupDate !== undefined &&
                                        <td>{visitorInfo.visitorHealthCheckupDate}</td>
                                }
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>*/}
                <tr>
                    <td colSpan={5}>
                        <table className="info_table" cellPadding="0" cellSpacing="0">
                            <tbody>
                            <tr>
                                <th>구분</th>
                                <th>시리얼번호</th>
                                <th>시리얼번호 확인</th>
                                <th>사용목적</th>
                                <th>비고</th>
                                <th>반입용량</th>
                                <th>반출용량</th>
                            </tr>
                            {
                                visitorInfo.checkStuffInfoVOS.map((row, index) => (
                                    <tr key={`stuffInfosKey-${index}`}>
                                        <td>{row.category}</td>
                                        <td>{row.serialNo}</td>
                                        <td>
                                            <input type={"text"}
                                                   className={"nv_input"}
                                                   name={'outSerialNo'}
                                                   onChange={(e) => stuffInfoChangeHandler(row, e)}
                                            />
                                        </td>
                                        <td>{row.purpose}</td>
                                        <td>{row.notice}</td>
                                        <td>{row.beforeData}</td>
                                        <td>
                                            <input type={"text"}
                                                   className={"nv_input"}
                                                   name={'afterData'}
                                                   onChange={(e) => stuffInfoChangeHandler(row, e)}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
            <button type="button" className="info_visit_btn" onClick={submit}>출문</button>
        </div>
        // </form>
    )
}

function ReCheckInComponent({visitorInfo}) {
    function submit() {
        // e.preventDefault();
        Api.reVisit(visitorInfo.visitorInfoSeq).then(res => window.location.reload());
    }
    return (
        // <form onSubmit={submit} style={{textAlign:'center'}}>
        <div className="tablebox" style={{paddingTop: '30px',textAlign:'center'}}>
            <h3 style={{textAlign:'left'}}>입출문 정보</h3>
            <table className="info_table" cellPadding="0" cellSpacing="0">
                <thead>
                <tr>
                    <th>방문일</th>
                    <th>방문증</th>
                    <th>입문일시</th>
                    <th>퇴문일시</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{visitorInfo.date}</td>
                    <td>{visitorInfo.card}</td>
                    <td>{visitorInfo.checkInTime}</td>
                    <td>{visitorInfo.checkOutTime}</td>
                </tr>
                {/*문진표 삭제 요청으로 주석처리*/}
               {/* <tr>
                    <td colSpan={4}>
                        <table className="info_table" cellPadding="0" cellSpacing="0">
                            <tbody>
                            <tr>
                                <th>위험지역방문여부</th>
                                <th>증상</th>
                                <th>온도</th>
                                {
                                    visitorInfo.visitorHealthCheckupDate !== undefined &&
                                    <th>건강검진일</th>
                                }
                            </tr>
                            <tr>
                                <td>
                                    {
                                        visitorInfo.surveyVo.visitAreaDangerous === 'true'
                                            ? `예(${visitorInfo.surveyVo.visitAreas1}, ${visitorInfo.surveyVo.visitAreas2}, ${visitorInfo.surveyVo.visitAreas3})`
                                            : '아니요'
                                    }
                                </td>
                                <td>
                                    {visitorInfo.surveyVo.symptoms.map(row => row)}
                                </td>
                                <td>{visitorInfo.temperature}</td>
                                {
                                    visitorInfo.visitorHealthCheckupDate !== undefined &&
                                    <td>{visitorInfo.visitorHealthCheckupDate}</td>
                                }
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>*/}
                <tr>
                    <td colSpan={4}>
                        <table className="info_table" cellPadding="0" cellSpacing="0">
                            <tbody>
                            <tr>
                                <th>구분</th>
                                <th>시리얼번호</th>
                                <th>사용목적</th>
                                <th>비고</th>
                                <th>반입용량</th>
                                <th>반출용량</th>
                            </tr>
                            {
                                visitorInfo.visitorStuffInfos.map((row, index) => (
                                    <tr key={`stuffInfosKey-${index}`}>
                                        <td>{row.category}</td>
                                        <td>{row.serialNo}</td>
                                        <td>{row.purpose}</td>
                                        <td>{row.notice}</td>
                                        <td>{row.beforeData}</td>
                                        <td>{row.afterData}</td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
            <button type="button" className="info_visit_btn" onClick={submit}>재방문</button>
        </div>

        // </form>
    )
}
